import { render, staticRenderFns } from "./TOSScreen.vue?vue&type=template&id=98dd90fc&scoped=true"
import script from "./TOSScreen.vue?vue&type=script&lang=js"
export * from "./TOSScreen.vue?vue&type=script&lang=js"
import style0 from "./TOSScreen.vue?vue&type=style&index=0&id=98dd90fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dd90fc",
  null
  
)

export default component.exports